export default "__VITE_ASSET__06ae9dd9__"